module.exports = __webpack_public_path__ + "img/type.8d3af3c1.png";